import * as yup from 'yup';

export type CreateEmployeeFormValues = {
    firstName: string;
    lastName: string;
    middleName?: string;
    email: string;
    phone?: string;
    taxAuthorityDepartment?: TaxAuthorityDepartmentOption | null;
};

type Translate = (key: string, replace?: Record<string, unknown>) => string;
type TaxAuthorityDepartmentOption = {label: string; value: number};

const taxAuthorityDepartmentShape = (t: Translate) =>
    yup.object({
        label: yup
            .string()
            .max(50, t('max_length', {max: 50}))
            .required(),
        value: yup.number().required(),
    });

export const getCreateEmployeeSchema = (t: Translate, isOperator: boolean) =>
    yup.object().shape({
        firstName: yup
            .string()
            .required(t('required'))
            .min(2, t('length_between', {min: 2, max: 50}))
            .max(50, t('length_between', {min: 2, max: 50})),
        lastName: yup
            .string()
            .required(t('required'))
            .min(2, t('length_between', {min: 2, max: 50}))
            .max(50, t('length_between', {min: 2, max: 50})),
        middleName: yup.string().max(50, t('max_length', {max: 50})),
        email: yup
            .string()
            .required(t('required'))
            .max(50, t('max_length', {max: 50}))
            .email(t('email')),
        phone: yup.string().max(50, t('max_length', {max: 50})),
        taxAuthorityDepartment: isOperator
            ? taxAuthorityDepartmentShape(t)
                  .nullable()
                  .required(t('required'))
            : yup
                  .mixed()
                  .nullable()
                  .notRequired(),
    });
